function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRePlantFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 12.8L29 16l1.5-3.7-3.9.5zM8 8.4l1.5-3.7-3.9.6L8 8.4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4c-1.048 0-2.152.096-3.137.365l-.526-1.93C13.552 2.104 14.847 2 16 2c6.575 0 12.273 4.73 13.675 10.878l-1.95.444C26.527 8.07 21.625 4 16 4zM5.56 21.99C2.71 17.112 3.811 10.925 7.781 7.232L6.419 5.768C1.79 10.074.49 17.284 3.837 23.005l.005.01a14.95 14.95 0 002.25 2.892l1.415-1.414A12.949 12.949 0 015.56 21.99zm20.908-.045c.512-.769.878-1.75 1.167-2.808l1.93.526c-.31 1.132-.739 2.341-1.417 3.367-3.339 5.682-10.212 8.264-16.254 6.322l.612-1.904c5.148 1.655 11.065-.553 13.93-5.453l.015-.025.017-.025z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 26.7l-4 .5 2.4 3.2 1.6-3.7z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.487 10.941a.847.847 0 01.557.966c-.252 1.338-1.03 4.218-3.164 5.45-1.53.884-3.445.74-4.88.422V25h-2v-7.221c-1.435.318-3.35.462-4.88-.421-2.135-1.233-2.911-4.113-3.164-5.45a.847.847 0 01.558-.967c1.285-.45 4.167-1.217 6.302.016.995.574 1.695 1.506 2.184 2.474.49-.968 1.19-1.9 2.185-2.474 2.134-1.233 5.017-.466 6.302-.016zm-1.648 1.595a8.74 8.74 0 01-.479 1.28c-.4.848-.9 1.475-1.48 1.81-.579.334-1.372.453-2.306.377a8.731 8.731 0 01-1.349-.225 8.74 8.74 0 01.48-1.28c.4-.848.9-1.475 1.48-1.81.579-.334 1.372-.453 2.306-.377a8.73 8.73 0 011.348.225zm-8.064 3.242a8.751 8.751 0 00-.48-1.28c-.4-.848-.9-1.475-1.48-1.81-.578-.334-1.372-.453-2.306-.377a8.73 8.73 0 00-1.348.226c.119.406.275.849.48 1.28.4.847.9 1.474 1.48 1.809.578.334 1.371.453 2.306.377a8.731 8.731 0 001.348-.225z",
    fill: props.color
  }));
}

export default SvgIconRePlantFilled;